/**
 * DB'de /uploads/... veya https://img-cdn... tutulur.
 * Panel kendi REACT_APP_API_URL ile /uploads cozer; CDN URL oldugu gibi kalir.
 */

const getApiUrl = () => {
  const base = process.env.REACT_APP_API_URL ?? 'http://localhost:3001';
  return base.replace(/\/$/, '');
};

const isCdnUrl = (src) =>
  typeof src === 'string' &&
  (src.includes('img-cdn.gisekibris.com') ||
    (src.startsWith('https://') && src.includes('/event/')));

/** Goruntu src'sini tarayicinin yukleyebilecegi absolute URL'ye cevir. */
export function resolveMediaUrl(src) {
  if (!src || typeof src !== 'string') return src;
  const trimmed = src.trim();
  if (!trimmed) return trimmed;

  if (trimmed.startsWith('data:') || trimmed.startsWith('blob:') || trimmed.startsWith('//')) {
    return trimmed.startsWith('//') ? `https:${trimmed}` : trimmed;
  }

  // CDN full URL — dokunma
  if (isCdnUrl(trimmed) || trimmed.startsWith('https://img-cdn.')) {
    return trimmed;
  }

  // Eski kayit: https://eski-domain.com/uploads/x.jpg -> mevcut API ile servis
  const uploadsIdx = trimmed.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    return `${getApiUrl()}${trimmed.slice(uploadsIdx)}`;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }

  return `${getApiUrl()}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}

/** DB'ye yazarken: CDN URL oldugu gibi; /uploads relative; blob/data at. */
export function toRelativeMediaSrc(src) {
  if (!src || typeof src !== 'string') return src;
  const trimmed = src.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) {
    return null;
  }

  // CDN URL DB'de full kalsin
  if (
    trimmed.includes('img-cdn.gisekibris.com') ||
    (trimmed.startsWith('https://') && trimmed.includes('/event/'))
  ) {
    return trimmed;
  }

  const uploadsIdx = trimmed.indexOf('/uploads/');
  if (uploadsIdx !== -1) {
    return trimmed.slice(uploadsIdx);
  }
  return trimmed;
}

/** Date / Blob / File gibi special object'leri plain object sanma. */
const isPlainObject = (value) =>
  value != null &&
  typeof value === 'object' &&
  !(value instanceof Date) &&
  !(value instanceof Blob) &&
  !(value instanceof File) &&
  !Array.isArray(value);

/** Nested kayitlarda { src } alanlarini relative'e cevir (kayit oncesi). */
export function stripMediaUrlsDeep(value) {
  if (Array.isArray(value)) {
    return value.map((item) => stripMediaUrlsDeep(item));
  }
  if (isPlainObject(value)) {
    const out = {};
    for (const [key, val] of Object.entries(value)) {
      // File / blob kalintisi DB'ye gitmesin
      if (key === 'rawFile') continue;
      if (key === 'src' && typeof val === 'string') {
        const relative = toRelativeMediaSrc(val);
        if (relative == null) continue;
        out[key] = relative;
      } else {
        out[key] = stripMediaUrlsDeep(val);
      }
    }
    // src'siz / bozulmus image objesini tamamen at
    if (
      Object.prototype.hasOwnProperty.call(value, 'src') &&
      out.src == null &&
      (value.rawFile != null ||
        (typeof value.src === 'string' &&
          (value.src.startsWith('blob:') || value.src.startsWith('data:'))))
    ) {
      return null;
    }
    return out;
  }
  return value;
}

/** Nested kayitlarda { src } alanlarini absolute yap (panel ImageField icin). */
export function expandMediaUrlsDeep(value) {
  if (Array.isArray(value)) {
    return value.map((item) => expandMediaUrlsDeep(item));
  }
  if (isPlainObject(value)) {
    const out = {};
    for (const [key, val] of Object.entries(value)) {
      if (key === 'src' && typeof val === 'string') {
        out[key] = resolveMediaUrl(val);
      } else {
        out[key] = expandMediaUrlsDeep(val);
      }
    }
    return out;
  }
  return value;
}
